import React from 'react';
import i18n from '@i18n';
import scrollTop from '@/root/scrollTop';
import { setScrollTop as desktopScrollTop } from '@/responsive/helpers/scroll';

export default function BackToTop() {
    return (
        <div
            onClick={() => {
                scrollTop();
                desktopScrollTop();
            }}
            className="back-to-top blue-link text-center"
        >
            {i18n('common.backToTop')}
        </div>
    );
}
